// extracted by css-extract-rspack-plugin
export default {"Card":"select-option-card_Card__VwrC8","Active":"select-option-card_Active__ft7OO","Title":"select-option-card_Title__4QB4t","Description":"select-option-card_Description__5hC7R"};